export const CHATBOT_CONFIG = {
    companyKey: process.env.KHOROS_CONFIG_COMPANY_KEY,
    appId: process.env.KHOROS_CONFIG_APP_ID,
    widgetId: process.env.KHOROS_CONFIG_WIDGET_ID,
}
